module.exports = __webpack_public_path__ + "img/person-fill.80841522.svg";